<template>
  <v-container fluid pa-0 class="dashboard-frame">
    <v-layout row wrap ma-0>
      <v-flex xs12 class="brightgrey-bg pa-2 d-flex align-center justify-space-between">
        <v-flex xs12>
          <p class="body-1 ml-3 mb-0">{{ 'วันที่ ' + filterdate }}</p>
          <p class="text-caption text--secondary ml-3 mb-0">
            {{ 'เปรียบเทียบกับวันที่ ' + comparedate }}
          </p>
        </v-flex>
        <FilterMenu @filterChange="onFilterChange" :festival="festival" />
      </v-flex>
      <!-- <v-flex xs1 class="d-flex align-center">
        <v-btn icon><v-icon>chevron_left</v-icon></v-btn>
      </v-flex>-->
      <v-flex xs12 pa-5 pt-10>
        <v-layout class="scroll">
          <div
            v-for="(item, index) in overviewData"
            :key="`overview-${index}`"
            :class="{ 'mr-4': overviewDataLength - 1 !== index }"
          >
            <OverviewSection :data-source="item" :festival="festival" />
          </div>
        </v-layout>
      </v-flex>
      <!-- <v-flex xs1 class="d-flex align-center">
        <v-btn icon><v-icon>chevron_right</v-icon></v-btn>
      </v-flex>-->
    </v-layout>
  </v-container>
</template>

<script>
import FilterMenu from './FilterMenu.vue';
import OverviewSection from './OverviewSection.vue';

export default {
  name: 'OverviewDashboard',
  components: {
    FilterMenu,
    OverviewSection
  },
  data: () => ({
    overviewData: [
      {
        title: 'อุบัติเหตุทางถนน',
        icon: {
          type: 'image',
          name: 'way_road'
        },
        dashboardName: 'road',
        showtoday: true,
        today: 0,
        total: 0,
        dead: {
          today: 0,
          total: 0
        },
        injure: {
          today: 0,
          total: 0
        },
        yearsData: [
          {
            title: 'อุบัติเหตุ',
            title2: '(ครั้ง)',
            data: [
              {
                year: '',
                amount: 0
              },
              {
                year: '',
                amount: 0
              }
            ],
            percentage: '0%'
          },
          {
            title: 'อุบัติเหตุที่มีผู้เสียชีวิต',
            title2: '(ครั้ง)',
            data: [
              {
                year: '',
                amount: 0
              },
              {
                year: '',
                amount: 0
              }
            ],
            percentage: '0%'
          },
          {
            title: 'ผู้เสียชีวิต',
            title2: '(คน)',
            data: [
              {
                year: '',
                amount: 0
              },
              {
                year: '',
                amount: 0
              }
            ],
            percentage: '0%'
          },
          {
            title: 'ผู้บาดเจ็บ',
            title2: '(คน)',
            data: [
              {
                year: '',
                amount: 0
              },
              {
                year: '',
                amount: 0
              }
            ],
            percentage: '0%'
          },
          {
            title: 'ผู้บาดเจ็บสาหัส',
            title2: '(คน)',
            data: [
              {
                year: '',
                amount: 0
              },
              {
                year: '',
                amount: 0
              }
            ],
            percentage: '0%'
          },
          {
            title: 'ผู้บาดเจ็บเล็กน้อย',
            title2: '(คน)',
            data: [
              {
                year: '',
                amount: 0
              },
              {
                year: '',
                amount: 0
              }
            ],
            percentage: '0%'
          }
        ]
      },
      {
        title: 'อุบัติเหตุทางราง',
        icon: {
          type: 'icon',
          name: 'fas fa-subway'
        },
        dashboardName: 'rail',
        showtoday: true,
        today: 0,
        total: 0,
        dead: {
          today: 0,
          total: 0
        },
        injure: {
          today: 0,
          total: 0
        },
        yearsData: [
          {
            title: 'อุบัติเหตุ',
            title2: '(ครั้ง)',
            data: [
              {
                year: '',
                amount: 0
              },
              {
                year: '',
                amount: 0
              }
            ],
            percentage: '0%'
          },
          {
            title: 'อุบัติเหตุที่มีผู้เสียชีวิต',
            title2: '(ครั้ง)',
            data: [
              {
                year: '',
                amount: 0
              },
              {
                year: '',
                amount: 0
              }
            ],
            percentage: '0%'
          },
          {
            title: 'ผู้เสียชีวิต',
            title2: '(คน)',
            data: [
              {
                year: '',
                amount: 0
              },
              {
                year: '',
                amount: 0
              }
            ],
            percentage: '0%'
          },
          {
            title: 'ผู้บาดเจ็บ',
            title2: '(คน)',
            data: [
              {
                year: '',
                amount: 0
              },
              {
                year: '',
                amount: 0
              }
            ],
            percentage: '0%'
          },
          {
            title: 'ผู้บาดเจ็บสาหัส',
            title2: '(คน)',
            data: [
              {
                year: '',
                amount: 0
              },
              {
                year: '',
                amount: 0
              }
            ],
            percentage: '0%'
          },
          {
            title: 'ผู้บาดเจ็บเล็กน้อย',
            title2: '(คน)',
            data: [
              {
                year: '',
                amount: 0
              },
              {
                year: '',
                amount: 0
              }
            ],
            percentage: '0%'
          }
        ]
      },
      {
        title: 'อุบัติเหตุทางน้ำ',
        icon: {
          type: 'icon',
          name: 'fas fa-ship'
        },
        dashboardName: 'water',
        showtoday: true,
        today: 0,
        total: 0,
        dead: {
          today: 0,
          total: 0
        },
        injure: {
          today: 0,
          total: 0
        },
        yearsData: [
          {
            title: 'อุบัติเหตุ',
            title2: '(ครั้ง)',
            data: [
              {
                year: '',
                amount: 0
              },
              {
                year: '',
                amount: 0
              }
            ],
            percentage: '0%'
          },
          {
            title: 'อุบัติเหตุที่มีผู้เสียชีวิต',
            title2: '(ครั้ง)',
            data: [
              {
                year: '',
                amount: 0
              },
              {
                year: '',
                amount: 0
              }
            ],
            percentage: '0%'
          },
          {
            title: 'ผู้เสียชีวิต',
            title2: '(คน)',
            data: [
              {
                year: '',
                amount: 0
              },
              {
                year: '',
                amount: 0
              }
            ],
            percentage: '0%'
          },
          {
            title: 'ผู้บาดเจ็บ',
            title2: '(คน)',
            data: [
              {
                year: '',
                amount: 0
              },
              {
                year: '',
                amount: 0
              }
            ],
            percentage: '0%'
          },
          {
            title: 'ผู้บาดเจ็บสาหัส',
            title2: '(คน)',
            data: [
              {
                year: '',
                amount: 0
              },
              {
                year: '',
                amount: 0
              }
            ],
            percentage: '0%'
          },
          {
            title: 'ผู้บาดเจ็บเล็กน้อย',
            title2: '(คน)',
            data: [
              {
                year: '',
                amount: 0
              },
              {
                year: '',
                amount: 0
              }
            ],
            percentage: '0%'
          }
        ]
      },
      {
        title: 'อุบัติเหตุทางอากาศ',
        icon: {
          type: 'icon',
          name: 'fas fa-plane'
        },
        dashboardName: 'air',
        showtoday: true,
        today: 0,
        total: 0,
        dead: {
          today: 0,
          total: 0
        },
        injure: {
          today: 0,
          total: 0
        },
        yearsData: [
          {
            title: 'อุบัติเหตุ',
            title2: '(ครั้ง)',
            data: [
              {
                year: '',
                amount: 0
              },
              {
                year: '',
                amount: 0
              }
            ],
            percentage: '0%'
          },
          {
            title: 'อุบัติเหตุที่มีผู้เสียชีวิต',
            title2: '(ครั้ง)',
            data: [
              {
                year: '',
                amount: 0
              },
              {
                year: '',
                amount: 0
              }
            ],
            percentage: '0%'
          },
          {
            title: 'ผู้เสียชีวิต',
            title2: '(คน)',
            data: [
              {
                year: '',
                amount: 0
              },
              {
                year: '',
                amount: 0
              }
            ],
            percentage: '0%'
          },
          {
            title: 'ผู้บาดเจ็บ',
            title2: '(คน)',
            data: [
              {
                year: '',
                amount: 0
              },
              {
                year: '',
                amount: 0
              }
            ],
            percentage: '0%'
          },
          {
            title: 'ผู้บาดเจ็บสาหัส',
            title2: '(คน)',
            data: [
              {
                year: '',
                amount: 0
              },
              {
                year: '',
                amount: 0
              }
            ],
            percentage: '0%'
          },
          {
            title: 'ผู้บาดเจ็บเล็กน้อย',
            title2: '(คน)',
            data: [
              {
                year: '',
                amount: 0
              },
              {
                year: '',
                amount: 0
              }
            ],
            percentage: '0%'
          }
        ]
      }
    ],
    filterdate: '',
    comparedate: '',
    festival: {},
    searchcondition: {}
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getDefaultFestival();
    },
    getDefaultFestival() {
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/festival/default`;
      this.axios.get(url).then(response => {
        if (response.status === 200 && response.data.data) {
          const { data } = response.data;
          const defaultfes = data.filter(member => {
            return member.isdefault;
          })[0];
          defaultfes.start_date = defaultfes.start_date.substr(0, 10);
          defaultfes.end_date = defaultfes.end_date.substr(0, 10);
          if (defaultfes.compare_start_date) {
            defaultfes.compare_start_date = defaultfes.compare_start_date.substr(0, 10);
          } else {
            const td = new Date(defaultfes.start_date);
            td.setFullYear(td.getFullYear() - 1);
            defaultfes.compare_start_date = this.utils.getLocalDate(td);
          }
          if (defaultfes.compare_end_date) {
            defaultfes.compare_end_date = defaultfes.compare_end_date.substr(0, 10);
          } else {
            const td = new Date(defaultfes.end_date);
            td.setFullYear(td.getFullYear() - 1);
            defaultfes.compare_end_date = this.utils.getLocalDate(td);
          }
          this.festival = defaultfes;
          const fesfrom = new Date(this.festival.start_date);
          const festo = new Date(this.festival.end_date);
          this.filterdate = this.getLastWeekPeriodDateWithText(fesfrom, festo);
          if (defaultfes.compare_start_date && defaultfes.compare_end_date) {
            this.comparedate = this.getLastWeekPeriodDateWithText(
              this.festival.compare_start_date,
              this.festival.compare_end_date
            );
          } else {
            fesfrom.setFullYear(fesfrom.getFullYear() - 1);
            festo.setFullYear(festo.getFullYear() - 1);
            this.comparedate = this.getLastWeekPeriodDateWithText(fesfrom, festo);
          }
          this.getAllCardData(defaultfes);
          defaultfes.search = 'tabSeason';
          this.setlocalSearchParam(defaultfes);
        }
      });
    },
    onFilterChange(val) {
      const start_date = new Date(val.start_date);
      const end_date = new Date(val.end_date);
      this.festival.start_date = val.start_date;
      this.festival.end_date = val.end_date;
      this.filterdate = this.getLastWeekPeriodDateWithText(start_date, end_date);
      if (val.compare_start_date && val.compare_end_date) {
        this.comparedate = this.getLastWeekPeriodDateWithText(
          val.compare_start_date,
          val.compare_end_date
        );
      } else {
        start_date.setFullYear(start_date.getFullYear() - 1);
        end_date.setFullYear(end_date.getFullYear() - 1);
        this.comparedate = this.getLastWeekPeriodDateWithText(start_date, end_date);
      }
      this.setlocalSearchParam(val);
      this.getAllCardData(val);
    },
    setlocalSearchParam(val) {
      localStorage.setItem('searchParams', JSON.stringify(val));
    },
    getAllCardData(searchcondition) {
      const params = {
        start_date: searchcondition.start_date,
        end_date: searchcondition.end_date,
        compare_start_date: searchcondition.compare_start_date,
        compare_end_date: searchcondition.compare_end_date,
        report_date: searchcondition.report_date || this.utils.getLocalDate(),
        report_time: searchcondition.report_time
      };
      this.getCardData('road', 0, params);
      this.getCardData('rail', 1, params);
      this.getCardData('water', 2, params);
      this.getCardData('air', 3, params);
    },
    getCardData(link, cardindex, searchcondition) {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/main/dashboard/summary/${link}`;
      this.axios
        .get(url, {
          params: searchcondition
        })
        .then(response => {
          if (response.status === 200 && response.data.data) {
            const { data } = response.data;
            const card = scope.overviewData[cardindex];
            card.today = data.accident.today;
            card.total = data.accident.summary;
            card.dead.today = data.dead.today;
            card.dead.total = data.dead.summary;
            card.injure.today = data.injury.today;
            card.injure.total = data.injury.summary;
            const today = scope.utils.getLocalDate();
            card.showtoday =
              searchcondition.start_date == today && searchcondition.end_date == today;
            const propname = [
              'accident_count',
              'dead_accident',
              'dead_amount',
              'injury_amount',
              'serious_injury_amount',
              'minor_injury_amount'
            ];
            for (let index = 0; index < propname.length; index += 1) {
              card.yearsData[index].data[0].year = data.statistic.compare_year;
              card.yearsData[index].data[0].amount = data.statistic[propname[index]].compare;
              card.yearsData[index].data[1].year = data.statistic.current_year;
              card.yearsData[index].data[1].amount = data.statistic[propname[index]].current;
              card.yearsData[index].percentage = data.statistic[propname[index]].percentage;
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getLastWeekPeriodDateWithText(from, to) {
      const start = this.utils.formatToDateThai(from);
      const end = this.utils.formatToDateThai(to);
      if (start == end) {
        return start;
      }
      return `${start} ถึง ${end}`;
    }
  },
  computed: {
    overviewDataLength() {
      return this.overviewData.length;
    }
  }
};
</script>

<style lang="scss" scoped>
.brightgrey-bg {
  background-color: var(--v-brightgrey-base);
}
.scroll {
  overflow: auto;
}
// @media screen and (min-width: 1366px){
//   .dashboard-frame {
//     width: 1128px;
//   }
// }
// @media screen and (max-width: 1366px){
//   .dashboard-frame {
//     max-width: 768px;
//   }
// }
</style>
